import {
    IMPORTED_TOURNAMENT_GET_SUMMARY_REQUEST,
    IMPORTED_TOURNAMENT_GET_SUMMARY_SUCCESS,
    IMPORTED_TOURNAMENT_GET_SUMMARY_FAILURE,
    IMPORTED_TOURNAMENT_GET_PLAYERS_REQUEST,
    IMPORTED_TOURNAMENT_GET_PLAYERS_SUCCESS,
    IMPORTED_TOURNAMENT_GET_PLAYERS_FAILURE,
    IMPORTED_TOURNAMENT_GET_DRAWS_REQUEST,
    IMPORTED_TOURNAMENT_GET_DRAWS_SUCCESS,
    IMPORTED_TOURNAMENT_GET_DRAWS_FAILURE,
    IMPORTED_TOURNAMENT_GET_FILTERS_REQUEST,
    IMPORTED_TOURNAMENT_GET_FILTERS_SUCCESS,
    IMPORTED_TOURNAMENT_GET_FILTERS_FAILURE,
    IMPORTED_TOURNAMENT_GET_RESULTS_REQUEST,
    IMPORTED_TOURNAMENT_GET_RESULTS_SUCCESS,
    IMPORTED_TOURNAMENT_GET_RESULTS_FAILURE,
} from '../actions/actionTypes/imported-tournament-action-types';

const initialState = {
    summary: {
        data: null,
        loading: false,
        error: null,
    },
    players: {
        data: [],
        totalCount: 0,
        loading: false,
        error: null,
    },
    draws: {
        data: [],
        loading: false,
        error: null,
    },
    filters: {
        data: null,
        loading: false,
        error: null,
    },
    results: {
        byDrawId: {},
        search: {
            draws: [],
            totalCount: 0,
            loading: false,
            error: null,
        },
    },
};

const getCachedDrawResult = (byDrawId, drawId) => byDrawId[drawId] ?? { matches: [], loading: false, error: null };

const findMatchesForDraw = (draws, drawId) => draws.find((draw) => draw.id === drawId)?.matches ?? [];

export default (state = initialState, action) => {
    switch (action.type) {
        case IMPORTED_TOURNAMENT_GET_SUMMARY_REQUEST: {
            return {
                ...state,
                summary: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_SUMMARY_SUCCESS: {
            return {
                ...state,
                summary: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_SUMMARY_FAILURE: {
            return {
                ...state,
                summary: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_PLAYERS_REQUEST: {
            return {
                ...state,
                players: {
                    data: [],
                    totalCount: 0,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_PLAYERS_SUCCESS: {
            return {
                ...state,
                players: {
                    data: action.payload.players,
                    totalCount: action.payload.totalCount,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_PLAYERS_FAILURE: {
            return {
                ...state,
                players: {
                    data: [],
                    totalCount: 0,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_DRAWS_REQUEST: {
            return {
                ...state,
                draws: {
                    data: [],
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_DRAWS_SUCCESS: {
            return {
                ...state,
                draws: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_DRAWS_FAILURE: {
            return {
                ...state,
                draws: {
                    data: [],
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_FILTERS_REQUEST: {
            return {
                ...state,
                filters: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_FILTERS_SUCCESS: {
            return {
                ...state,
                filters: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_FILTERS_FAILURE: {
            return {
                ...state,
                filters: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_RESULTS_REQUEST: {
            const { drawId, search } = action.payload.queryParams ?? {};

            if (search) {
                return {
                    ...state,
                    results: {
                        ...state.results,
                        search: { ...state.results.search, loading: true, error: null },
                    },
                };
            }

            if (!drawId) {
                return state;
            }

            // Deviates from the REQUEST-clears-data convention used elsewhere in this reducer: a
            // draw already fetched must survive collapse/re-expand, so this sets loading without
            // clearing the cached matches.
            return {
                ...state,
                results: {
                    ...state.results,
                    byDrawId: {
                        ...state.results.byDrawId,
                        [drawId]: { ...getCachedDrawResult(state.results.byDrawId, drawId), loading: true, error: null },
                    },
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_RESULTS_SUCCESS: {
            const { queryParams, data } = action.payload;
            const { drawId, search } = queryParams ?? {};

            if (search) {
                return {
                    ...state,
                    results: {
                        ...state.results,
                        search: { draws: data.draws, totalCount: data.totalCount, loading: false, error: null },
                    },
                };
            }

            if (!drawId) {
                return state;
            }

            return {
                ...state,
                results: {
                    ...state.results,
                    byDrawId: {
                        ...state.results.byDrawId,
                        [drawId]: { matches: findMatchesForDraw(data.draws, drawId), loading: false, error: null },
                    },
                },
            };
        }
        case IMPORTED_TOURNAMENT_GET_RESULTS_FAILURE: {
            const { queryParams, status, showReloadButton } = action.payload;
            const { drawId, search } = queryParams ?? {};
            const errorPayload = { status, showReloadButton };

            if (search) {
                return {
                    ...state,
                    results: {
                        ...state.results,
                        search: { draws: [], totalCount: 0, loading: false, error: errorPayload },
                    },
                };
            }

            if (!drawId) {
                return state;
            }

            return {
                ...state,
                results: {
                    ...state.results,
                    byDrawId: {
                        ...state.results.byDrawId,
                        [drawId]: { matches: [], loading: false, error: errorPayload },
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
};
